import { useState, Fragment } from 'react';
import { Flex, Box, Text } from 'rebass/styled-components';
import { IPresetPlanSummary } from '../../../graphql/types/queries/presetPlans';
import { PresetPlanAnswers } from './PresetPlanAnswers';
import { HoverableCard, IProgram } from '../LastCourses';
import { useLazyQuery, useQuery } from '@apollo/client';
import { GET_HC_PATIENT_CALENDLY_EVENTS, GET_HEALTH_COACH_VISIT_SUMMARIES_ALL, GET_PATIENT_BY_ID } from '../../../graphql/queries';
import { IGetHealthCoachVisitSummariesOutput, IGetHealthCoachVisitSummariesInput, IHealthCoachVisitSummary } from '../../../graphql/types/queries/healthCoaching';
import { IGetProviderPatientByIdOutput, IGetProviderPatientByIdInput } from '../../../graphql/types/queries/patient';
import PleaseWait from '../../../components/PleaseWait';
import styled from 'styled-components';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import moment from 'moment';
import { EnhancedModal } from '../../../components/EnhancedModal';
import { VisitSummary } from '../visitSummary/VisitSummary';
import { ICalendlyEvent, IGetPatientCalendlyEventsInput, IGetPatientCalendlyEventsOutput } from '../../../graphql/types/queries/appointment';

const ListContainer = styled(Flex)`
  width: 100%;
  overflow-y: auto;
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
  &.selected {
    display: none;
  }
`;

const iconStyle = {
  width: '20px',
  height: '20px',
  background: '#FFFFFF',
  border: '3px solid #BCFFEB',
  margin: '10px',
  boxShadow: 'initial'
}

const contentStyle = {
  background: '#F0F5FD',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.05)',
  borderRadius: '10px',
  padding: '12px 0px',
}
const contentStyleMinimized = {
  background: '#F0F5FD',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.05)',
  borderRadius: '10px',
  padding: '12px 0px',
  marginBottom: '12px'
}
const contentArrowStyle = {
  borderRight: '7px solid  #F0F5FD',
}

const SelectorLarge = styled(Flex)`
  display: none;
  @media screen and (min-width: 1740px) {
    display: initial;
  }
`

const SelectorSmall = styled(Flex)`
  display: none;
  @media screen and (max-width: 1739px) {
    display: initial;
  }
`
const VisitSummaryButton = styled(Flex)`
  padding: 4px 16px;
  background: #e4e4e4 ;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    background: #c5f1fa ;
  }
`

export const AppointmentDisplay = ({ athenaId, userId, dataSummaries, calendly }: { athenaId: string, userId?: string, dataSummaries: IHealthCoachVisitSummary, calendly: ICalendlyEvent | null | undefined }) => {
  console.log({ dataSummaries })
  const [checkout, setCheckout] = useState(false)

  return (
    <Flex flexDirection={'column'} width='100%'>
      <Flex flexDirection={['column', 'row', 'row']}>
        <Flex flexDirection={['row', 'column', 'column']} width={['100%', '120px', '120px']} paddingX={['12px', 0, 0]} justifyContent={['flex-start', 'center', 'center']} alignItems='center'>
          <Flex flexDirection={'column'}>
            <Text fontWeight={400} fontSize='14px'>{`${calendly ? moment(calendly.startTime).format('MM/DD/YYYY') : 'unknown'}`}</Text>
            <Text fontWeight={300} fontSize='12px'>{calendly ? moment(calendly.startTime).format('hh:mmA z') : ''}</Text>
          </Flex>
        </Flex>
        <Box style={{ height: '48px', background: '#E2E2E2', width: '1px' }} display={['none', 'initial', 'initial']} />
        <Flex mt={[2, 0, 0]} ml={2} flex={1} flexDirection={'column'} width={['100%', '180px', '180px']} paddingX={['12px', 0, 0]} justifyContent={['flex-start', 'center', 'center']} alignItems={['flex-start', 'center', 'flex-start']}>
          <Flex flexDirection={'column'}>
            <Text fontWeight={300} color='rgba(52, 79, 122, 0.6)' fontSize='12px'>Event Name</Text>
            <Text fontWeight={300} fontSize='14px'>{calendly ? calendly.name : 'Visit'}</Text>
          </Flex>
        </Flex>
        <Box style={{ height: '48px', background: '#E2E2E2', width: '1px' }} mr={2} display={['none', 'initial', 'initial']} />
        <VisitSummaryButton onClick={() => {
          setCheckout(true)
        }} justifySelf={'flex-end'} alignSelf={'center'} mr={3} alignItems={'center'}>
          <Box mr={2} style={{ background: 'green', height: '6px', width: '6px', borderRadius: '4px' }} />
          <Text fontWeight={300} fontSize='12px'>Checked-out</Text>
        </VisitSummaryButton>


      </Flex>
      {!!checkout && !!userId && dataSummaries.calendlyUri && (
        <EnhancedModal
          containerStyle={{ paddingRight: 0, marginRight: 0 }}
          isOpen={!!checkout}
          onClose={() => setCheckout(false)}>
          <VisitSummary calendlyUri={dataSummaries.calendlyUri} athenaId={athenaId} userId={userId} onClose={() => setCheckout(false)} />
        </EnhancedModal>
      )}
    </Flex>
  )
}

export const ShowVisits = ({ program, id }: { program: IProgram; id: string; }) => {

  const { data, loading, error } = useQuery<IGetPatientCalendlyEventsOutput, IGetPatientCalendlyEventsInput>(GET_HC_PATIENT_CALENDLY_EVENTS, {
    variables: {
      id: id
    }
  })
  const [loadSummaries, { data: dataSummaries, loading: loadingSummaries }] = useLazyQuery<IGetHealthCoachVisitSummariesOutput, IGetHealthCoachVisitSummariesInput>(GET_HEALTH_COACH_VISIT_SUMMARIES_ALL)
  const { data: dataPatient, loading: loadingPatient, error: errorPatient } = useQuery<IGetProviderPatientByIdOutput, IGetProviderPatientByIdInput>(GET_PATIENT_BY_ID, {
    variables: {
      id
    },
    onCompleted: e => {
      if (e.getProviderPatientById && e.getProviderPatientById.user) {
        loadSummaries({
          variables: {
            userId: e.getProviderPatientById.user
          }
        })
      }
    }
  })

  return (
    <>
      <Flex alignItems={'center'} mb={4} ml={'12px'} mt={2}>
        <Text style={{ fontSize: '22px', fontWeight: 600 }}>{`Health coach visits related to the course`}</Text>
      </Flex>
      {!!loadingPatient || !!loadingSummaries || loading ? (
        <Flex flex={1} justifyContent={'center'} alignItems={'center'}>
          <PleaseWait />
        </Flex>
      ) : (
        <ListContainer>
          {dataSummaries && dataSummaries.healthCoachGetPatientVisitSummaries && (dataSummaries.healthCoachGetPatientVisitSummaries).filter(x=>x.courseId===program.value).length > 0 ? (
            <>
              <VerticalTimeline layout='1-column' lineColor='#344F7A' >
                {(dataSummaries.healthCoachGetPatientVisitSummaries).filter(x=>x.courseId===program.value).map(x => {
                  const calendly = data && data.healthCoachGetCalendlyEventsForPatient && data.healthCoachGetCalendlyEventsForPatient.events ? data.healthCoachGetCalendlyEventsForPatient.events.find(xx => xx.uri === x.calendlyUri) : null
                  return (
                    <VerticalTimelineElement
                      className="vertical-timeline-element--work"
                      contentStyle={contentStyle}
                      contentArrowStyle={contentArrowStyle}
                      style={{
                        margin: 0,
                        marginBottom: '12px',
                      }}
                      iconStyle={iconStyle} key={x.calendlyUri}
                    >
                      <AppointmentDisplay calendly={calendly} dataSummaries={x} userId={(dataPatient?.getProviderPatientById || {} as any).user} athenaId={id} />
                    </VerticalTimelineElement>)
                })}
              </VerticalTimeline>
            </>
          ) : (
            <Flex m={4} justifyContent='center' alignItems={'center'} width='100%'>
              <Text textAlign='center'>No health coach visit checked-out for the selected course</Text>
            </Flex>
          )}
        </ListContainer>
      )}
    </>
  );
};
